import { createSelector } from '@reduxjs/toolkit';
import { flattenPageGroups } from './flattenPageGroups';
import { getPageGroups } from './getPageGroups';

export const getPages = createSelector(getPageGroups, (pageGroups) => flattenPageGroups(pageGroups));
